new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {
      
    },
})

$(document).ready(function () {

    if (window.matchMedia("(max-width: 991px)").matches) {
        const footerSection = document.querySelectorAll('.section-footer');
        if(footerSection.length) {
            footerSection.forEach((item) => {
                let footerTitle = item.querySelector('.footer-title');
                if(footerTitle) {
                    footerTitle.addEventListener('click', () => {
                        item.classList.toggle('active');
                    });
                }
            });
        }
    }

});